<template>
  <div class="widget-container">
    <div class="tool" :class="{ active: showAISearch }" @click="$emit('handleMenu', 'AI')" title="Chat Window">
      <fa :icon="['fas', 'search']" class="icon" size="1x" />
    </div>
    <div class="tool" :class="{ active: showFeatures }" title="Road features" @click="$emit('handleMenu', 'Features')">
      <fa :icon="['fas', 'info-circle']" class="icon" size="1x" />
    </div>
    <div class="tool" id="base-maps" :class="{ active: basemap }" @click="$emit('handleMenu', 'Map')" title="Switch Map">
      <fa :icon="['fas', 'map']" class="icon" size="1x" />
    </div>
    <div class="tool" id="logout" @click="$emit('handleMenu', 'SignOut')" title="Logout">
      <fa :icon="['fas', 'sign-out-alt']" class="icon" size="1x" />
    </div>
  </div>
</template>

<style scoped>
.widget-container {
  background-color: #063c6d;
  height: 40px;
  width: 200px;
  border-radius: 0.25rem;
  box-shadow: 0 2px 8px rgba(6, 60, 109, 0.25);
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  overflow: hidden;
}

.widget-container .tool {
  height: 100%;
  width: 50px;
  padding: 0;
  border: none;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 0;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease;
  flex-shrink: 0;
}

.widget-container .tool:last-child {
  border-right: none;
}

.widget-container .tool:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.widget-container .tool .icon {
  height: 14px;
  width: 14px;
}

.widget-container .tool.active {
  background: rgba(255, 255, 255, 0.22) !important;
  color: #fff;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.3);
}
</style>

<script>
export default {
  name: 'AI_Widgets',
  props: [
    'showAISearch',
    'showFeatures',
    'basemap'
  ]
}
</script>
